module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "pricing-table section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("Perfect pricing plan")]), _vm._v(" "), _c('p', [_vm._v("gormless cheeky bugger he nicked it golly gosh a arse show off show off")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-table text-center mb-4 mb-md-0"
  }, [_c('div', {
    staticClass: "table-top"
  }, [_c('h3', [_vm._v("basic")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "my-5"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Marketing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Builder")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Client Testing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Multiple Email Support")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Read Recepient")]), _vm._v(" "), _c('li', [_vm._v("User Free")])]), _vm._v(" "), _c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Buy now")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-table text-center mb-4 mb-md-0"
  }, [_c('div', {
    staticClass: "table-top"
  }, [_c('h3', [_vm._v("standard")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "my-5"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Marketing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Builder")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Client Testing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Multiple Email Support")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Read Recepient")]), _vm._v(" "), _c('li', [_vm._v("User Free")])]), _vm._v(" "), _c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Buy now")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-table text-center"
  }, [_c('div', {
    staticClass: "table-top"
  }, [_c('h3', [_vm._v("premium")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-building-o"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "my-5"
  }, [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Marketing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Builder")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Client Testing")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Multiple Email Support")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("Email Read Recepient")]), _vm._v(" "), _c('li', [_vm._v("User Free")])]), _vm._v(" "), _c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Buy now")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pricing-box section-padding3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "single-box1 text-center mb-4 mb-md-0"
  }, [_c('h3', [_vm._v("submit resume today")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore.")]), _vm._v(" "), _c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("submit your cv")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "single-box2 text-center"
  }, [_c('h3', [_vm._v("post a new job now!")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore.")]), _vm._v(" "), _c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("post a job")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79ecfa83"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PricingPlan.vue
// module id = 265
// module chunks = 1